<template>
  <b-overlay :show="formShow" rounded="sm" no-fade class="mt-1">
    <b-card>
      <b-row class="mb-1">
        <b-col
          cols="12"
          md="7"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <b-button
            variant="outline-primary"
            class="btn-icon"
            @click="$router.go(-1)"
          >
            <i class="fa-solid fa-arrow-left"></i>
            <span class="ml-25">Back</span>
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mb-1">
        <table class="table table-sm">
          <thead>
            <tr>
              <th scope="col" v-if="workingGroupId">Working Group Edit</th>
              <th scope="col" v-else>Working Group Add</th>
            </tr>
          </thead>
        </table>
      </b-row>

      <validation-observer ref="workingGroupRules">
        <b-form>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group label="Group Name" label-for="group_name">
                <validation-provider
                  name="group name"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="workingGroupValue.group_name"
                    class="form-control"
                    id="group_name"
                    name="group_name"
                    rows="3"
                    placeholder="Enter Group Name"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group
                label="Terms of Reference"
                label-for="terms_of_reference"
              >
                <validation-provider
                  name="terms of reference"
                  #default="{ errors }"
                  rules="required"
                >
                  <textarea
                    v-model="workingGroupValue.terms_of_reference"
                    class="form-control"
                    id="terms_of_reference"
                    name="terms_of_reference"
                    rows="3"
                    placeholder="Enter Terms of Reference"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Users" label-for="user">
                <validation-provider name="user" #default="{ errors }">
                  <v-select
                    v-model="workingGroupValue.user_ids"
                    :reduce="(val) => val.id"
                    label="email"
                    limit="10"
                    :multiple="true"
                    :options="users"
                    :clearable="true"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group
                label="Attached Document"
                label-for="attached_document"
              >
                <b-form-file
                  v-model="workingGroupValue.attached_document"
                  :placeholder="
                    isEdit && existingDocument
                      ? existingDocument
                      : 'Choose a PDF file or drop it here...'
                  "
                  drop-placeholder="Drop PDF file here..."
                  :value="isEdit && existingDocument ? existingDocument : null"
                  accept=".pdf,application/pdf"
                />
              </b-form-group>

              <div v-if="isEdit && existingDocument" class="mt-1">
                <b-button
                  variant="secondary"
                  size="sm"
                  class="mr-1"
                  @click="downloadDocument"
                >
                  <i class="fas fa-download"></i> Download working group
                  document
                </b-button>
                <b-button variant="danger" size="sm" @click="removeDocument">
                  <i class="fas fa-trash"></i> Remove document
                </b-button>
              </div>
            </b-col>

            <b-col cols="6" sm="12" md="6">
              <b-row>
                <b-col cols="6" sm="12" md="6">
                  <b-form-group label="Start Date">
                    <validation-provider
                      name="start date"
                      #default="{ errors }"
                    >
                      <flat-pickr
                        v-model="workingGroupValue.start_date"
                        class="form-control"
                        :config="flatPickrConfig"
                        @on-change="validateDates"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6" sm="12" md="6">
                  <b-form-group label="End Date">
                    <validation-provider name="end date" #default="{ errors }">
                      <flat-pickr
                        v-model="workingGroupValue.end_date"
                        class="form-control"
                        :config="flatPickrConfig"
                        @on-change="validateDates"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>

            <b-col cols="12" md="6" v-if="canSetGovernance">
              <b-form-group label="Governance">
                <b-form-checkbox
                  v-model="workingGroupValue.is_governance"
                  switch
                >
                  Governance group (private to Chairpersons / Directors)
                </b-form-checkbox>
                <small class="text-muted">
                  Governance groups are hidden from the Working Group Tool and
                  shown only under the Governance menu.
                </small>
              </b-form-group>
            </b-col>

            <!-- <b-col cols="12" md="6" v-if="workingGroupId">
              <b-form-group label="Status" label-for="status">
                <validation-provider
                  name="status"
                  #default="{ errors }"
                  rules="required"
                >
                  <v-select
                    v-model="workingGroupValue.status"
                    :options="['Active', 'Passive']"
                    :clearable="false"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->
          </b-row>

          <hr />

          <b-row>
            <b-col cols="12">
              <b-button
                type="submit"
                @click.prevent="formSubmitted"
                variant="primary"
                class="float-right "
              >
                {{ isEdit ? "Update Working Group" : "Save Working Group" }}
              </b-button>

              <b-button
                v-if="isEdit"
                type="button"
                @click.prevent="showSubsections"
                variant="warning"
                class="float-right mr-2 "
              >
                Show Subsections
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </b-overlay>
</template>
<script>
import store from "@/store";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { onUnmounted } from "@vue/composition-api";
import settingsStoreModule from "../settingsStoreModule";
import vSelect from "vue-select";
import router from "@/router";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import axiosIns from "@/libs/axios";

export default {
  components: {
    vSelect,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },

  setup() {
    const OBJECT_CODE_APP_STORE_MODULE_NAME = "settings";
    // Register module
    if (!store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
      store.registerModule(
        OBJECT_CODE_APP_STORE_MODULE_NAME,
        settingsStoreModule
      );

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(OBJECT_CODE_APP_STORE_MODULE_NAME))
        store.unregisterModule(OBJECT_CODE_APP_STORE_MODULE_NAME);
    });
  },

  props: {
    isEdit: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      workingGroupValue: {
        group_name: "",
        terms_of_reference: "",
        user_ids: [],
        attached_document: null,
        start_date: null,
        end_date: null,
        status: "Active",
        is_governance: false,
      },
      existingDocument: null,
      existingDocumentUrl: null,
      users: [],
      formShow: false,
      workingGroupId: null,
      flatPickrConfig: {
        enableTime: false,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "F j, Y",
      },
    };
  },

  watch: {},

  computed: {
    // Only supermanager / admin may move a group in or out of Governance
    canSetGovernance() {
      const role = this.userData ? this.userData.role : null;
      return role === "supermanager" || role === "admin";
    },
  },

  mounted() {
    this.getWorkingGroupById();
    this.getUsers();
  },

  methods: {
    getUsers() {
      store.dispatch("settings/workingGroupUsers").then((res) => {
        this.users = res.data;
      });
    },

    getWorkingGroupById() {
      if (router.currentRoute.params.id) {
        this.formShow = true;

        store
          .dispatch("settings/getWorkingGroupById", {
            id: router.currentRoute.params.id,
          })
          .then((res) => {
            this.workingGroupValue = {
              group_name: res.data.group_name,
              terms_of_reference: res.data.terms_of_reference,
              user_ids: res.data.user_ids,
              start_date: res.data.start_date,
              end_date: res.data.end_date,
              status: res.data.status,
              is_governance: !!res.data.is_governance,
              id: res.data.id,
            };
            // Handle existing document
            this.existingDocument = res.data.attached_document_name ?? null;
            this.existingDocumentUrl = res.data.attached_document_url;

            this.workingGroupId = res.data.id;
            this.formShow = false;
          })
          .catch((error) => {
            console.log(error);
            this.formShow = false;
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "An error occurred",
                text: "Please try again later or contact support.",
                icon: "AlertCircleIcon",
                variant: "danger",
              },
            });
          });
      }
    },

    async downloadDocument() {
      if (this.isEdit && router.currentRoute.params.id) {
        return new Promise((resolve, reject) => {
          axiosIns
            .get(
              `/workingGroup/downloadAttachedDocument/${router.currentRoute.params.id}`,
              {
                responseType: "blob",
              }
            )
            .then((response) => {
              const contentType = response.headers["content-type"];
              const url = window.URL.createObjectURL(
                new Blob([response.data], { type: contentType })
              );
              const link = document.createElement("a");
              link.href = url;

              // Get filename from content-disposition header
              const contentDisposition =
                response.headers["content-disposition"];
              let fileName = this.existingDocument + "_working_group_document";

              if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(
                  /filename="(.+)"/
                );
                if (fileNameMatch && fileNameMatch.length === 2) {
                  fileName = fileNameMatch[1];
                }
              } else {
                // If no filename in header, determine extension based on content-type
                switch (contentType) {
                  case "application/pdf":
                    fileName += ".pdf";
                    break;
                  case "application/vnd.ms-excel":
                    fileName += ".xls";
                    break;
                  case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    fileName += ".xlsx";
                    break;
                  case "application/msword":
                    fileName += ".doc";
                    break;
                  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
                    fileName += ".docx";
                    break;
                  default:
                    fileName += ".txt";
                    break;
                }
              }

              link.setAttribute("download", fileName);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);

              resolve(response);
            })
            .catch((error) => {
              console.error("Download failed:", error);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Error",
                  text: "Failed to download file",
                  variant: "danger",
                },
              });
              reject(error);
            });
        });
      }
    },

    formSubmitted() {
      this.formShow = true;

      this.$refs.workingGroupRules.validate().then((success) => {
        if (success) {
          const formData = new FormData();
          Object.keys(this.workingGroupValue).forEach((key) => {
            if (key === "attached_document" && this.workingGroupValue[key]) {
              formData.append(key, this.workingGroupValue[key]);
            } else if (key === "user_ids" && this.workingGroupValue[key]) {
              this.workingGroupValue[key].forEach((id) => {
                formData.append("user_ids[]", id);
              });
            } else if (key === "is_governance") {
              if (this.canSetGovernance) {
                formData.append(key, this.workingGroupValue[key] ? 1 : 0);
              }
            } else if (this.workingGroupValue[key] !== null) {
              formData.append(key, this.workingGroupValue[key]);
            }
          });

          if (this.workingGroupId == null) {
            store
              .dispatch("settings/saveWorkingGroup", formData)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Working Group Add Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-working-groups" });
              })
              .catch((error) => {
                this.formShow = false;
                console.log(error);
                const errorMessage =
                  error.response?.data?.errors?.group_name?.[0] ||
                  "An error occurred while saving the working group.";
                this.handleError(errorMessage);
              });
          } else {
            store
              .dispatch("settings/updateWorkingGroup", formData)
              .then((response) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successfully",
                    text: "✔️ Working Group Update Successful",
                    icon: "ThumbsUpIcon",
                    variant: "success",
                  },
                });

                router.push({ name: "settings-working-groups" });
              })
              .catch((error) => {
                this.formShow = false;
                console.log(error);
                const errorMessage =
                  error.response?.data?.errors?.group_name?.[0] ||
                  "An error occurred while saving the working group.";
                this.handleError(errorMessage);
              });
          }
        } else {
          this.formShow = false;
        }
      });
    },

    showSubsections() {
      this.$emit("showSubsections", this.workingGroupId);
    },

    handleError(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Error",
          text: message,
          icon: "AlertCircleIcon",
          variant: "danger",
        },
      });
      this.formShow = false;
    },

    validateDates() {
      if (
        this.workingGroupValue.start_date &&
        this.workingGroupValue.end_date
      ) {
        const startDate = new Date(this.workingGroupValue.start_date);
        const endDate = new Date(this.workingGroupValue.end_date);

        if (endDate < startDate) {
          this.workingGroupValue.start_date = null;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Date Error",
              text: "Start date cannot be later than end date",
              icon: "AlertCircleIcon",
              variant: "danger",
            },
          });
        }
      }
    },

    removeDocument() {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to remove this document?", {
          title: "Confirm Removal",
          okVariant: "danger",
          okTitle: "Remove",
          cancelTitle: "Cancel",
        })
        .then((value) => {
          if (value) {
            store
              .dispatch(
                "settings/removeWorkingGroupDocument",
                this.workingGroupId
              )
              .then(() => {
                this.existingDocument = null;
                this.existingDocumentUrl = null;
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Successful",
                    text: "✔️ Document removed successfully",
                    icon: "TrashIcon",
                    variant: "success",
                  },
                });
              })
              .catch((error) => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Error",
                    text: "Failed to remove document",
                    icon: "AlertCircleIcon",
                    variant: "danger",
                  },
                });
              });
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
